import { Icon, Intent, Tag, Tooltip } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React from 'react'
import EmptyPlaceholder from '../../../components/EmptyPlaceholder'

const prettyErrors = errors => (
  <ul style={{ marginTop: 5 }}>
    {Object.keys(errors).map(e => (
      <li key={e}>
        {e.replace(/([A-Z])/g, (_, p1) => ` ${p1.toLowerCase()}`)}: {errors[e].join(',')}
      </li>
    ))}
  </ul>
)

const style = {
  concurrentStepTag: {
    marginTop: 4
  }
}

export const ListingStrategyCell = ({ name, errors, isConcurrent }) => {
  if (errors) {
    return (
      <>
        <Tooltip wrapperTagName="div" targetTagName="div">
          <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
            <Icon intent={Intent.DANGER} icon={IconNames.ERROR} /> {name}
          </div>
          <div>
            {name}
            <div>{prettyErrors(errors)}</div>
          </div>
        </Tooltip>
        {isConcurrent && (
          <Tag style={style.concurrentStepTag} icon={IconNames.SEND_TO_GRAPH} intent={Intent.SUCCESS} minimal>
            CONCURRENT STEP
          </Tag>
        )}
      </>
    )
  }
  return (
    <EmptyPlaceholder style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
      {name && (
        <>
          <div>{name}</div>
          {isConcurrent && (
            <Tag style={style.concurrentStepTag} icon={IconNames.SEND_TO_GRAPH} intent={Intent.SUCCESS} minimal>
              CONCURRENT STEP
            </Tag>
          )}
        </>
      )}
    </EmptyPlaceholder>
  )
}
